import { useOrgInfo, MenuLabels } from '../use-org-info/use-org-info';

export type MenuLabelKey =
  | 'dashboardHome'
  | 'dashboardResources'
  | 'dashboardImpact'
  | 'volunteeringActivities'
  | 'volunteeringActivityReport'
  | 'volunteeringIncidentReport'
  | 'managementDashboard'
  | 'managementActivityManagement'
  | 'managementRosters'
  | 'managementVolunteers'
  | 'managementBulletins'
  | 'managementReportManagement'
  | 'managementIncidentManagement'
  | 'adminTaskManagement'
  | 'adminProgramManagement'
  | 'adminConsole';

const defaultLabels: Record<MenuLabelKey, string> = {
  dashboardHome: 'My Elements',
  dashboardResources: 'Resources',
  dashboardImpact: 'Impact Dashboard',
  volunteeringActivities: 'Explore',
  volunteeringActivityReport: 'Activity Report',
  volunteeringIncidentReport: 'Incident Report',
  managementDashboard: 'Dashboard',
  managementActivityManagement: 'Activity Management',
  managementRosters: 'Rosters',
  managementVolunteers: 'Volunteers',
  managementBulletins: 'Bulletins',
  managementReportManagement: 'Report Management',
  managementIncidentManagement: 'Incident Management',
  adminTaskManagement: 'Task Management',
  adminProgramManagement: 'Program Management',
  adminConsole: 'Admin Console',
};

export const useMenuLabel = (key: MenuLabelKey): string => {
  const orgInfo = useOrgInfo();
  const customLabel = orgInfo?.menuLabels?.[key];
  return customLabel || defaultLabels[key];
};

export const getMenuLabel = (key: MenuLabelKey, menuLabels?: MenuLabels | null): { label: string; customLabel?: string } => {
  const customLabel = menuLabels?.[key];
  return {
    label: defaultLabels[key],
    customLabel: customLabel || undefined
  };
};
